import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCheck, FaCheckDouble, FaTimes } from "react-icons/fa";
import axios from 'axios';
import translations from '../translations';

function UserCards({ setLoading }) {
  const email = localStorage.getItem('userEmail');
  const [cards, setCards] = useState([]);
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'en');
  const t = translations[language];

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/senaraikad/${email}`)
      .then(response => {
        const cards = response.data;
        setCards(cards);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, [email, setLoading]);

  return (
    <div className="max-w-lg">
      <h2 className="text-2xl font-semibold mb-4">{t.yourWeddingRsvp}</h2>
      <div>
        {cards.map(card => (
          <div key={card.card_id} className="bg-white shadow-md rounded-lg p-4 mb-4">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-semibold mb-2">{t.id} {card.card_id}</h3>
              <Link to={`/dashboard/${card.card_id}`} className="btn-primary inline-flex items-center px-4 py-2 rounded-md">
                {t.access}
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default UserCards;
